import { normalizeSearchExpression, emptyFishingSelection } from "./core.js";
import { buildQueryCatalogIndex, queryCatalogCandidates, queryCatalogRecordMatch } from "../../js/query/catalog-index.js";
import { specialItemReferenceForTitle, GOD_OF_FISHING_TITLE_ID } from "../map-special-item-references.js";
import { normalizeSearchTerm } from "./terms.js";


const indexes = new WeakMap();
export function matchingFishingTitles(titles, value) {
  if (!Array.isArray(titles)) return [];
  let index = indexes.get(titles);
  if (!index) {
    index = buildQueryCatalogIndex(titles.map(value => ({ value, values: [value.name, String(value.titleId)] })));
    indexes.set(titles, index);
  }
  const query = String(value).trim();
  if (!query) return titles;
  if (/^\d+$/.test(query)) return titles.filter(title => title.titleId === Number(query));
  return queryCatalogCandidates(index, query).filter(record => queryCatalogRecordMatch(index, record, query).rank > 0).map(record => record.value);
}

export function resolveFishingTitleReference(value, options) {
  const titles = options?.catalog?.titles;
  if (!Array.isArray(titles)) return { status: "catalog_unavailable" };
  const matches = matchingFishingTitles(titles, value);
  const exact = matches.filter(title => title.name?.toLocaleLowerCase() === String(value).trim().toLocaleLowerCase());
  const selected = exact.length ? exact : matches;
  return selected.length === 1 ? { status: "resolved", term: { kind: "title", titleId: selected[0].titleId } }
    : { status: selected.length ? "ambiguous" : "unknown" };
}

export function expressionUsesTitles(node) {
  if (!node) return false;
  if (node.type === "term") return node.term?.kind === "title" || node.term?.status === "missing-titles";
  return node.type === "container" ? expressionUsesTitles(node.expression) : node.children?.some(expressionUsesTitles) === true;
}

export function resolveTitleExpression(expression, projection, catalogItems = []) {
  const normalized = normalizeSearchExpression(expression);
  if (!expressionUsesTitles(normalized)) return normalized;
  // Unavailable evidence must never become a broad match under negation.
  if (projection?.kind !== "ready") return emptyFishingSelection();
  function visit(node) {
    if (node.type === "term") {
      if (!expressionUsesTitles(node)) return node;
      if (node.term.kind === "title" && node.term.titleId === GOD_OF_FISHING_TITLE_ID) {
        const reference = specialItemReferenceForTitle(node.term.titleId, catalogItems);
        return reference
          ? { ...node, term: normalizeSearchTerm(reference) }
          : emptyFishingSelection(node.negated);
      }
      const itemIds = node.term.kind === "title"
        ? projection.titleItems.filter(entry => entry.titleId === node.term.titleId).map(entry => entry.itemId)
        : projection.missingTitleItemIds;
      return itemIds.length ? { ...node, term: { kind: "item-group", itemIds } } : emptyFishingSelection(node.negated);
    }
    return node.type === "container" ? { ...node, expression: visit(node.expression) }
      : { ...node, children: node.children.map(visit) };
  }
  return visit(normalized);
}
